import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllUsersMetrics } from 'domain/usecases';

export class RemoteGetAllUsersMetrics implements GetAllUsersMetrics {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllUsersMetrics.Result>,
  ) {}

  async execute(
    params?: GetAllUsersMetrics.Params,
  ): Promise<GetAllUsersMetrics.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        groups: params.group,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
